export const fontFamilies = {
  mono: "'JetBrains Mono', 'Fira Code', 'Consolas', monospace",
  body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  display: "'Space Grotesk', 'Inter', sans-serif",
};

export const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};
